export enum DesignTypes {
  Actual = 'ACTUAL',
  Prototype = 'PROTOTYPE',
  Planned = 'PLANNED',
}